import {FormErrors} from 'lookup-config/LookupConfigModalConstants';

const INVALID_LOOKUP_OBJECT_ERROR_TEXT = 'Invalid lookup object.';

export function getLookupFormErrorMessage(
  errorText: string,
  errors: FormErrors,
  errorKey: keyof FormErrors,
  invalidLookupObjectErrorCallback?: () => JSX.Element
): string | JSX.Element | null {
  if (errors[errorKey]) {
    return errorText;
  } else if (errors.invalidLookupObjectError) {
    if (invalidLookupObjectErrorCallback != null) {
      return invalidLookupObjectErrorCallback();
    }
    return INVALID_LOOKUP_OBJECT_ERROR_TEXT;
  }
  return null;
}
